import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import '../styles/Login.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { isValidPhoneNumber } from "libphonenumber-js";
import axios from 'axios';
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUser, setIsAuthenticated, isAuthenticated } = useAuth()

  const [authPhone, setAuthPhone] = useState(true)
  const [authEmail, setAuthEmail] = useState(false)

  const [phone, setPhone] = useState('');

  const [isPasswordClose, setIsPasswordClose] = useState(true)

  const passwordRef = useRef(null)

  const handlePhoneChange = (value) => {
    setPhone(value);
    console.log('Selected phone:', value);
  };


  const [defaultCountry, setDefaultCountry] = useState('ru'); // Страна по умолчанию (запасной вариант)
  const [isValid, setIsValid] = useState(true);
  useEffect(() => {
    // Получение страны по IP
    const fetchCountryCode = async () => {
      try {
        const response = await axios.get('https://ipapi.co/json/'); // Используется IP-API
        const countryCode = response.data.country_code.toLowerCase(); // Получаем код страны в нижнем регистре
        setDefaultCountry(countryCode);
      } catch (error) {
        console.error('Ошибка при определении страны:', error);
      }
    };

    fetchCountryCode();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!isValid) {
      return
    }
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token); // Сохраняем токен в локальном хранилище
        setUser(data.user);
        setIsAuthenticated(true)
        navigate('/games/aviator')
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Ошибка авторизации");
      }
    } catch (err) {
      setError("Сетевая ошибка");
      console.error("Ошибка входа:", err);
    }
  };

  const phoneSubmit = async (e) => {
    e.preventDefault()
    if(!isValid) {
      return
    }
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/login-phone`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber: phone, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token); // Сохраняем токен в локальном хранилище
        setUser(data.user);
        setIsAuthenticated(true)
        navigate('/games/aviator')
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Ошибка авторизации");
      }
    } catch (err) {
      setError("Сетевая ошибка");
      console.error("Ошибка входа:", err);
    }
  }

  useEffect(() => {
    if(passwordRef) {
      isPasswordClose ? passwordRef.current.type = 'password' : passwordRef.current.type = 'text'
    }
  }, [isPasswordClose])

  useEffect(() => {
    if (isAuthenticated === true) {
      navigate('/games/aviator')
    }
  }, [isAuthenticated])

  return (
    <div className={'login-wrapper'}>
      <div className={'login-container-wrap'}>
      <h1>Login</h1>
      <p className={'login-container-welcome'}>Welcome to AviatorWinn</p>
      
      <div className={'auth-check-wrap'}>
        <div className={`auth-phone ${authPhone ? "active" : ""}`} onClick={() => {
          if(authPhone) {
            return
          } else {
            setAuthPhone(true)
            setAuthEmail(false)
            if(error !== "") {
              setError("")
            }
          }
        }}>
          <p><img src={authPhone ? "/assets/img/main/phone-black-icon.svg" : "/assets/img/main/phone-white-icon.svg"} alt="" /> Phone Number</p>
        </div>
        <div className={`auth-email ${authEmail ? "active" : ""}`} onClick={() => {
          if(authEmail) {
            return
          } else {
            setAuthEmail(true)
            setAuthPhone(false)
            setIsValid(true)
            if(error !== "") {
              setError("")
            }
          }
        }}>
          <p><img src={authEmail ? "/assets/img/main/mail-white.svg" : "/assets/img/main/mail-black.svg"} alt="" /> Email</p>
        </div>
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form className={'login-form-container'} onSubmit={authEmail ? handleSubmit : phoneSubmit}>
      {authPhone && <div className={'phone-number-input-wrapper'}>
            <PhoneInput
            id="phone-input"
        country={defaultCountry}
        value={phone}
        onChange={handlePhoneChange}
        enableSearch={true} // Включение поиска
        inputStyle={{
          width: '100%',
          height: '40px',
          borderColor: isValid ? 'initial' : 'red', // Цвет бордера при ошибке
        }}
        
      />
      {!isValid && <div style={{ color: 'red', fontSize: '12px' }}>Некорректный номер телефона</div>}
    </div>}
        {authEmail && <div className={'login-email-wrapper'}>
          <img className={'login-email-wrapper-img'} src="/assets/img/main/Mail.svg" alt="" />
        <input
        className={'login-email-input'}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
            if(error !== "") {
              setError("")
            }
          }}
          required
        />
        </div>}
        <div className={'login-password-wrapper'}>
          <img src="/assets/img/main/password.svg" alt="" />
          <div className={'login-password-wrapper-img'}></div>
        <input

        className={'login-password-input'}
          ref={passwordRef}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
            if(error !== "") {
              setError("")
            }
          }}
          required
        />
        <img className={'login-close-eye'} src={isPasswordClose ? "/assets/img/main/eye.png" : "/assets/img/main/view.png"} alt="" onClick={() => setIsPasswordClose((prev) => !prev)} />
        </div>
        <button className={'login-form-button'} type="submit" onClick={() => {
          if(authPhone) {
            setIsValid(isValidPhoneNumber(`+${phone}`))
          }
        }}>Login</button>
      </form>
      <div className={'login-wrapper-footer'}>Still no account? <span className={'font-bold'} onClick={() => {
        navigate('/registration')
      }}>Register</span></div>
      </div>
    </div>
  );
};

export default Login;